import * as z from "zod";

export const removeVariantExchangeItem = {
  name: "removeVariantExchangeItem" as const,
  input: z.object({
    teamId: z.string(),
    returnId: z.string(),
    variantId: z.string(),
  }),
  output: z.object({ success: z.boolean() }),
};
